// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon('eva:pie-chart-2-fill'),
    permission: ['SUPER_ADMIN', 'SUB_ADMIN'],
  },
  {
    title: 'categories',
    path: '/dashboard/category',
    icon: getIcon('heroicons:flag-20-solid'),
    permission: ['SUPER_ADMIN', 'SUB_ADMIN'],
  },
  {
    title: 'feeds',
    path: '/dashboard/feed',
    icon: getIcon('fluent-emoji-high-contrast:newspaper'),
    permission: ['SUPER_ADMIN', 'SUB_ADMIN'],
  },
  {
    title: 'audience',
    path: '/dashboard/user',
    icon: getIcon('eva:people-fill'),
    permission: ['SUPER_ADMIN', 'SUB_ADMIN'],
  },
  {
    title: 'comments',
    path: '/dashboard/comment',
    icon: getIcon('material-symbols:comment-rounded'),
    permission: ['SUPER_ADMIN', 'SUB_ADMIN'],
  },
  {
    title: 'subscriptions',
    path: '/dashboard/subscription',
    icon: getIcon('eos-icons:product-subscriptions'),
    permission: ['SUPER_ADMIN'],
  },
  {
    title: 'admins',
    path: '/dashboard/account',
    icon: getIcon('eos-icons:admin'),
    permission: ['SUPER_ADMIN'],
  },
  {
    title: 'authors',
    path: '/dashboard/author',
    icon: getIcon('fluent-emoji-high-contrast:writing-hand'),
    permission: ['SUPER_ADMIN'],
  },
  {
    title: 'promotions',
    path: '/dashboard/promotion',
    icon: getIcon('mdi:link-box-variant'),
    permission: ['SUPER_ADMIN', 'SUB_ADMIN'],
  },
  {
    title: 'contact us',
    path: '/dashboard/message',
    icon: getIcon('fluent-emoji-high-contrast:incoming-envelope'),
    permission: ['SUPER_ADMIN'],
  },
  {
    title: 'settings',
    path: '/dashboard/settings',
    icon: getIcon('fluent-emoji-high-contrast:gear'),
    permission: ['SUPER_ADMIN'],
  },
];

export default navConfig;
